import { FormControlLabel, Checkbox } from '@mui/material';
import { FieldType } from '../../types';


export const CustomCheckboxText = ({
  itemData,
  value,
  isInvalid,
  handleAccept,
}: {
  itemData: FieldType;
  value: boolean;
  isInvalid: boolean;
  handleAccept: () => void;
}) => {

  return <FormControlLabel
    control={
      <Checkbox
        value={value}
        name={itemData.config.fieldName}
        checked={value}
        onChange={handleAccept}
      />
    }
    label={
      <div
        style={{ color: isInvalid ? '#d32f2f' : 'inherit' }}
        dangerouslySetInnerHTML={{
          __html: itemData.config.checkboxText!,
        }}
      ></div>
    }
  />
};
